<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >

    <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <TableEntries
            v-model="perPage"
            :options="perPageOptions"
          />
          <Button
            v-if="getUserPermission('OUTWARD_CHEQUE_DEPOSIT_POSTING')"
            :label="$t('Post')"
            size="md"
            class="mt-0"
            @click="goToAddChequeDeposit"
          />
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-lg-end">
            <Button
              :label="$t('Filter')"
              size="md"
              icon="FilterIcon"
              show-icon
              class="mr-1"
              @click="showModal('modal-filter')"
            />
            <Button
              :label="$t('Reset Filter')"
              size="md"
              icon="RotateCwIcon"
              show-icon
              @click="resetFilter"
            />
          </div>
        </b-col>
      </b-row>

    </div>

    <b-table
      ref="customerInfoRef"
      :items="cachedChequeDepositList ? cachedChequeDepositList.data : chequeDepositList"
      responsive
      :busy="isBusy"
      :per-page="pageSize"
      :current-page="currentPage"
      :fields="translatedTableHeaders"
      primary-key="id"
      show-empty
      :empty-text="$t('No records available')"
      class="position-relative"
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner
            class="align-middle"
            variant="primary"
          />
        </div>
      </template>

      <template #cell(SN)="data">
        {{ getOverallIndex(data.index) }}
      </template>

      <template #cell(amount)="data">
        {{ toBalance(data.value) }}
      </template>

      <template #cell(status)="data">
        <b-badge
          pill
          :variant="getStatusColor(data.value)"
        >
          {{ data.value }}
        </b-badge>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">
        <div class="text-nowrap">
          <!-- Dropdown -->
          <!-- v-if="data.item.status === 'uncleared'" -->
          <b-dropdown
            variant="link"
            toggle-class="p-0"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              v-if="data.item.status === 'Uncleared'"
              @click="handleClearCheque(data.item)"
            >
              <feather-icon icon="CheckSquareIcon" />
              <span class="align-middle ml-50"> {{ $t('Clear Cheque') }} </span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="data.item.status === 'Uncleared'"
              @click="handleReturnCheque(data.item, $event.target, 'return')"
            >
              <feather-icon icon="RotateCwIcon" />
              <span class="align-middle ml-50"> {{ $t('Return Cheque') }} </span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="data.item.status === 'Uncleared'"
              @click="handleReturnCheque(data.item, $event.target, 'cancel')"
            >
              <feather-icon icon="RotateCcwIcon" />
              <span class="align-middle ml-50"> {{ $t('Cancel Cheque') }} </span>
            </b-dropdown-item>
            <b-dropdown-item @click="onViewChequeDeposit(data.item)">
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50"> {{ $t('View') }} </span>
            </b-dropdown-item>
          </b-dropdown>

        </div>
      </template>

    </b-table>

    <TablePagination
      v-model="currentPage"
      :from="from"
      :to="to"
      :total-rows="totalEntries"
      :per-page="perPage"
    />

    <!-- modal -->
    <b-modal
      id="modal-lg"
      ref="my-modal"
      :title="$t('Cheque Deposit')"
      :ok-title="$t('Print Receipt')"
      no-close-on-backdrop
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      modal-footer
      hide-footer
    >
      <div class="text-center">
        <h3> {{ $t('Posting Reference') }}: {{ chequeDepositData.referenceNumber }}</h3>
      </div>

      <TableEntries
        v-model="transactionPerPage"
        :options="perPageOptions"
      />

      <b-table
        ref="chequeDepositTransactionRef"
        :items="transactionList"
        responsive
        :busy="isBusy"
        :per-page="transactionPageSize"
        :current-page="transactionCurrentPage"
        :fields="translatedTransactionTableHeaders"
        primary-key="id"
        show-empty
        :empty-text="$t('No records available')"
        class="position-relative mt-3"
      >
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner
              class="align-middle"
              variant="primary"
            />
          </div>
        </template>

        <template #cell(SN)="data">
          {{ getOverallIndex(data.index) }}
        </template>

      </b-table>

      <TablePagination
        v-model="transactionCurrentPage"
        :from="transactionFrom"
        :to="transactionTo"
        :total-rows="transactionTotalEntries"
        :per-page="transactionPerPage"
      />
      <hr>
      <div class="d-flex align-items-center justify-content-lg-end">
        <Button
          :label="$t('Cancel')"
          size="md"
          class="mr-1"
          variant="outline-secondary"
          @click="cancelButton"
        />
        <Button
          :label="$t('POS Printer')"
          size="md"
          icon="PrinterIcon"
          show-icon
          class="mr-1"
          @click="posPrintReceipt"
        />
        <Button
          :label="$t('Billing Printer')"
          size="md"
          icon="PrinterIcon"
          show-icon
          @click="billingPrintReceipt"
        />
      </div>
    </b-modal>
    <!-- modal -->

    <!-- Filter modal -->
    <b-modal
      id="modal-filter"
      ref="my-modal"
      :ok-title="$t('Apply')"
      no-close-on-backdrop
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="$t('Filters')"
      modal-footer
      @ok="fetchChequeDeposit"
      @cancel="resetFilters"
    >
      <b-row class="match-height">

        <!-- Account Number -->
        <b-col md="6">
          <InputField
            id="account-number"
            v-model="filter.accountNumber"
            :label="$t('Account Number')"
            :placeholder="$t('Enter account number')"
            type="text"
          />
        </b-col>
        <!-- Account Number -->

        <!-- Branch -->
        <b-col md="6">
          <SelectField
            id="branch"
            v-model="filter.branchCode"
            :label="$t('Branch')"
            :placeholder="$t('Select Branch')"
            :options="branchOptions"
            :reduce="option => option.value"
            item="label"
          />
          <!-- Branch -->
        </b-col>

        <!-- Financial Date From -->
        <b-col md="6">
          <DatePickerField
            id="financial-date-from"
            v-model="filter.financialDateFrom"
            :label="$t('Financial Date(From')"
            :config="datePickerConfig"
          />
        </b-col>
        <!-- Financial Date From-->

        <!-- Financial Date To -->
        <b-col md="6">
          <DatePickerField
            id="financialDateTo"
            v-model="filter.financialDateTo"
            :label="$t('Financial Date(To)')"
            :config="datePickerConfig"
          />
        </b-col>
        <!-- Financial Date To-->

        <!-- Transaction Date From -->
        <b-col md="6">
          <DatePickerField
            id="Transaction-date-from"
            v-model="filter.transactionDateFrom"
            :label="$t('Transaction Date(From)')"
            :config="datePickerConfig"
          />
        </b-col>
        <!-- Transaction Date From-->

        <!-- Transaction Date To -->
        <b-col md="6">
          <DatePickerField
            id="TransactionDateTo"
            v-model="filter.transactionDateTo"
            :label="$t('Transaction Date(To)')"
            :config="datePickerConfig"
          />
        </b-col>
        <!-- Transaction Date To-->

        <!--Posting Reference Number -->
        <b-col md="6">
          <InputField
            id="reference-number"
            v-model="filter.postingReferenceNumber"
            :label="$t('Posting Reference Number')"
            :placeholder="$t('Enter posting reference number')"
            type="text"
          />
        </b-col>
        <!-- Posting Reference Number -->

        <b-col md="6">
          <SelectField
            id="clearing-bank"
            v-model="filter.clearingBank"
            :label="$t('Clearing Bank')"
            :options="clearingBankOptions"
            :placeholder="$t('Select')"
            :reduce="option => option.value"
            item="label"
          />
        </b-col>

        <!-- Cheque Number -->
        <b-col md="6">
          <InputField
            id="cheque-number"
            v-model="filter.chequeNumber"
            :label="$t('Cheque Number')"
            :placeholder="$t('Enter Cheque number')"
            type="text"
          />
        </b-col>
        <!-- Clearing Cheque Number -->

        <!-- Drawer bank -->
        <b-col md="6">
          <SelectField
            id="drawer-bank"
            v-model="filter.drawerBank"
            :label="$t('Drawer Bank')"
            :options="bankOptions"
            :placeholder="$t('Select')"
            :reduce="option => option.value"
            item="label"
          />
        </b-col>
        <!-- Drawer bank -->

        <b-col md="6">
          <SelectField
            id="status"
            v-model="filter.clearingStatus"
            :label="$t('Clearing Status')"
            :placeholder="$t('Select')"
            :options="statusOptions"
            item="label"
            :reduce="option => option.value"
          />
        </b-col>
      </b-row>
    </b-modal>
    <!-- Filter modal -->

    <!-- Print Transaction Receipt -->
    <div
      id="transaction-receipt-print"
    >
      <div id="prints">

        <b-card>
          <b-row
            no-gutters
          >
            <b-col
              md="12"
              style="text-align: center; margin-top: -70px;"
            >
              <img
                :src="userData.institutionLogoURL ? userData.institutionLogoURL : reportInfo.orgLogo"
              >
              <p
                v-if="corporateDetails"
                style="font-size: 2rem; text-align: center;"
                class="mt-2"
              >
                {{ corporateDetails.registeredAddress }}
              </p>
              <p
                style="font-family: 'Gill Sans Extrabold', sans-serif; font-size: 3rem; font-weight: 600; text-align: center; white-space: nowrap"
                class="mt-4"
              >
                {{ $t('Transaction Receipt') }}
              </p>
            </b-col>
          </b-row>
          <b-row no-gutters>
            <b-col
              md="8"
              :style="printerFirstStyle"
            >
              <div class="watermark">
                <b-card-body>
                  <b-card-text>
                    <div class="watermark__inner">
                      <div class="watermark__body">
                        {{ corporateDetails.registeredName }}
                      </div>
                    </div>
                    <table
                      :style="printerSecondStyle"
                      style="display: table; table-layout: fixed;"
                    >
                      <tbody>
                        <tr>
                          <td style="font-size: 2rem; padding-top: 3rem; color:#bbb; white-space: nowrap">
                            {{ $t('Transaction Type') }}
                          </td>
                          <td style="text-align: right; font-size: 2rem; padding-top: 3rem; font-weight: 700; color:#aaa;">
                            {{ $t('Cheque Deposit') }}
                          </td>
                        </tr>
                        <tr>
                          <td style="font-size: 2rem; color:#bbb; padding-top: 3rem; white-space: nowrap">
                            {{ $t('Account Number') }}
                          </td>
                          <td style="text-align: right; font-size: 2rem; padding-top: 3rem; color:#aaa; text-transform: capitalize; line-height: 1;">
                            {{ chequeDepositData.accountNumber }}
                          </td>
                        </tr>
                        <tr>
                          <td style="font-size: 2rem; color:#bbb; padding-top: 3rem; white-space: nowrap;">
                            {{ $t('Account Name') }}
                          </td>
                          <td style="text-align: right; font-size: 2rem; padding-top: 3rem; color:#aaa; line-height: 1;">
                            {{ chequeDepositData.accountName }}
                          </td>
                        </tr>
                        <tr>
                          <td style="font-size: 2rem; padding-top: 3rem; color:#bbb; white-space: nowrap">
                            {{ $t('Amount') }}
                          </td>
                          <td style="text-align: right; font-size: 2rem; padding-top: 3rem; font-weight: 700; color:#aaa; line-height: 1;">
                            {{ toBalance(chequeDepositData.amount) }}
                          </td>
                        </tr>
                        <tr>
                          <td style="font-size: 2rem; color:#bbb; padding-top: 3rem; white-space: nowrap">
                            {{ $t('Branch') }}
                          </td>
                          <td style="text-align: right; font-size: 2rem; padding-top: 3rem; color:#aaa; line-height: 1;">
                            {{ chequeDepositData.branch }}
                          </td>
                        </tr>
                        <tr>
                          <td style="font-size: 2rem; padding-top: 3rem; color:#bbb; white-space: nowrap">
                            {{ $t('Instrument Number') }}
                          </td>
                          <td style="text-align: right; font-size: 2rem; padding-top: 3rem; color:#aaa; line-height: 1;">
                            {{ chequeDepositData.instrumentNumber }}
                          </td>
                        </tr>
                        <tr>
                          <td style="font-size: 2rem; padding-top: 3rem; color:#bbb; white-space: nowrap;">
                            {{ $t('Posting Reference') }}
                          </td>
                          <td style="text-align: right; font-size: 2rem; padding-top: 3rem; color:#aaa; line-height: 1;">
                            {{ chequeDepositData.referenceNumber }}
                          </td>
                        </tr>
                        <tr>
                          <td style="font-size: 2rem; padding-top: 3rem; color:#bbb; white-space: nowrap">
                            {{ $t('Details') }}
                          </td>
                          <td style="text-align: right; font-size: 2rem; padding-top: 3rem; color:#aaa; line-height: 1;">
                            {{ chequeDepositData.narration }}
                          </td>
                        </tr>
                        <tr>
                          <td style="font-size: 2rem; padding-top: 3rem; color:#bbb; white-space: nowrap">
                            {{ $t('Teller') }}
                          </td>
                          <td style="text-align: right; font-size: 2rem; padding-top: 3rem; color:#aaa; line-height: 1;">
                            {{ chequeDepositData.initiator }}
                          </td>
                        </tr>
                        <tr>
                          <td style="font-size: 2rem; padding-top: 3rem; color:#bbb; white-space: nowrap">
                            {{ $t('Transaction Date') }}
                          </td>
                          <td style="text-align: right; font-size: 2rem; padding-top: 3rem; color:#aaa; line-height: 1;">
                            {{ chequeDepositData.transactionDate ? chequeDepositData.transactionDate : '' }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-card-text>
                </b-card-body>
              </div>
            </b-col>
          </b-row>
        </b-card>
        <!-- This repeats on every printed page -->
        <div
          v-if="institutionDetails.regulatoryFooter"
          class="print-footer"
        >
          {{ institutionDetails.regulatoryFooter }}
        </div>
      </div>
    </div>
    <!-- Print Transaction Receipt -->

    <FullScreenSpinner :show="showSpinner" />
  </b-card>

</template>

<script>
import {
  BCard, BCardBody, BCardText, BRow, BCol, BTable, BBadge,
  BSpinner, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { permissionMixin } from '@core/mixins/permission'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { mapActions, mapGetters } from 'vuex'
import TablePagination from '@/views/components/table/TablePagination.vue'
import { toAmount, toBalance } from '@/helpers/formatAmount'
import TableEntries from '@/views/components/table/TableEntries.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import getStatusColor from '@/helpers/getStatusColor'
import { toDateWithYear, toDateWithTime } from '../../../../../helpers/formatDate'
import InputField from '../../../../forms/InputField.vue'
import SelectField from '../../../../forms/SelectField.vue'
import DatePickerField from '../../../../forms/DatePickerField.vue'
import Button from '../../../../components/button/Button.vue'

export default {
  components: {
    BCard,
    BCardBody,
    BCardText,
    BRow,
    BCol,
    Button,
    BBadge,
    BSpinner,
    BTable,
    TablePagination,
    TableEntries,
    BDropdown,
    BDropdownItem,
    InputField,
    SelectField,
    FullScreenSpinner,
    DatePickerField,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      toDateWithYear,
      toDateWithTime,
      toAmount,
      toBalance,
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'accountNumber', sortable: true, label: 'Account Number' },
        { key: 'accountName', sortable: true, label: 'Account Name' },
        { key: 'branch', sortable: true, label: 'Branch' },
        { key: 'financialDate', sortable: true, label: 'Financial Date' },
        { key: 'transactionDate', sortable: true, label: 'Transaction Date' },
        { key: 'referenceNumber', sortable: true, label: 'Posting Reference' },
        { key: 'amount', sortable: true, label: 'Amount' },
        { key: 'clearingBank', sortable: true, label: 'Clearing Bank' },
        { key: 'clearingDate', sortable: true, label: 'Clearing Date' },
        { key: 'chequeNumber', sortable: true, label: 'Cheque Number' },
        { key: 'drawerName', sortable: true, label: 'Drawer Name' },
        { key: 'drawerBankName', sortable: true, label: 'Drawer Bank' },
        { key: 'narration', sortable: true, label: 'Narration' },
        { key: 'entryCode', sortable: true, label: 'Sort Code' },
        { key: 'initiatedBy', sortable: true, label: 'Initiated By' },
        { key: 'approvedBy', sortable: true, label: 'Approver' },
        { key: 'status', sortable: true, label: 'Clearing Status' },
        { key: 'actions', label: 'Actions' },
      ],
      transactionTableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'accountNumber', sortable: true, label: 'Account Number' },
        { key: 'accountName', sortable: true, label: 'Account Name' },
        { key: 'debit', sortable: true, label: 'Debit' },
        { key: 'credit', sortable: true, label: 'Credit' },
        { key: 'branch', sortable: true, label: 'Branch' },
        { key: 'instrumentNumber', sortable: true, label: 'Instrument Number' },
        { key: 'entryCode', sortable: true, label: 'Sort Code' },
      ],
      categoryFormData: {
        categoryName: '',
        level: 'Select',
        specifyLevel: 'Select',
      },
      chequeDepositList: [],
      clearingBankOptions: [],
      statusOptions: [
        { label: 'Auto Cleared', value: 'AutoCleared' },
        { label: 'Manually Cleared', value: 'ManuallyCleared' },
        { label: 'Canceled', value: 'Canceled' },
        { label: 'Returned', value: 'Returned' },
        { label: 'Uncleared', value: 'Uncleared' },
      ],
      chequeDepositData: {
        accountNumber: '',
        accountName: '',
        branch: '',
        financialDate: '',
        transactionDate: '',
        postingReferenceNumber: '',
        credit: '',
        entryCode: '',
        instrumentNumber: '',
        initiatedBy: '',
        initiator: '',
        narration: '',
        approver: '',
        senderName: '',
      },
      filter: {
        accountNumber: null,
        branchCode: null,
        financialDateFrom: null,
        financialDateTo: null,
        transactionDateFrom: null,
        postingReferenceNumber: null,
        clearingBank: null,
        chequeNumber: null,
        drawerBank: null,
        clearingStatus: null,
      },
      datePickerConfig: {
        dateFormat: 'Y-m-d',
      },
      getStatusColor,
      transactionList: [],
      transactionPerPage: 10,
      transactionPageSize: 0,
      transactionCurrentPage: 1,
      transactionTotalCount: 0,
      showSpinner: false,
      postingReferenceNumber: null,
      corporateDetails: {},
      printerFirstStyle: {
        width: '',
        marginLeft: '',
        marginRight: '',
      },
      printerSecondStyle: {
        width: '',
        marginLeft: '',
        marginRight: '',
      },
      institutionDetails: {
        regulatoryFooter: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      branchOptions: 'operations/branchOptions',
      userData: 'auth/getCurrentUser',
      bankOptions: 'operations/bankOptions',
    }),
    ...mapGetters('tableCache', ['getTableCache']),
    cacheKey() {
      // Use page + perPage + filter as cacheKey
      return JSON.stringify({ page: this.currentPage, perPage: this.perPage, filter: this.filter })
    },
    cachedChequeDepositList() {
      return this.getTableCache('cheque-deposit', this.cacheKey)
    },
    transactionTotalEntries() {
      return this.transactionTotalCount
    },
    transactionNumberOfPages() {
      return Math.floor((this.transactionTotalEntries + this.transactionPerPage - 1) / this.transactionPerPage)
    },
    transactionFrom() {
      if (this.transactionTotalCount === 0) {
        return 0
      }
      return (this.transactionCurrentPage * this.transactionPerPage) - (this.transactionPerPage - 1)
    },
    transactionTo() {
      return Math.min(this.transactionFrom + this.transactionPerPage - 1, this.transactionTotalEntries)
    },
    translatedTableHeaders() {
      return this.tableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedTransactionTableHeaders() {
      return this.transactionTableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
  },
  watch: {
    currentPage(newValue) {
      this.currentPage = newValue
      this.serveCacheAndFetchChequeDeposits()
    },
    perPage(newValue) {
      this.perPage = newValue
      this.serveCacheAndFetchChequeDeposits()
    },
    transactionCurrentPage(newValue) {
      this.transactionCurrentPage = newValue
      this.fetchPostings(this.postingReferenceNumber)
    },
    transactionPerPage(newValue) {
      this.transactionPerPage = newValue
      this.fetchPostings(this.postingReferenceNumber)
    },
  },
  mounted() {
    this.serveCacheAndFetchChequeDeposits()
    this.fetchCorporateInformation()
    this.getAccounts()
    this.fetchInstitutionData()
  },
  methods: {
    ...mapActions({
      getPostingsReport: 'reports/getTransactionReports',
      clearChequeAction: 'posting/clearChequeAction',
      returnChequeAction: 'posting/returnChequeAction',
      getChequeClearingAccountList: 'operations/getChequeClearingAccountList',
      getCorporateInformation: 'operations/getCorporateInformationList',
      getInstitutionData: 'operations/getInstitutionFileUploadList',
    }),
    ...mapActions('tableCache', ['setTableCache', 'markTableCacheStale', 'clearTableCache']),

    async serveCacheAndFetchChequeDeposits() {
      const { cacheKey } = this
      const cache = this.getTableCache('cheque-deposit', cacheKey)

      if (cache && cache.data) {
        this.chequeDepositList = cache.data
        this.totalCount = cache.totalCount
        this.isBusy = false
        this.fetchChequeDeposit(true)
      } else {
        // No cache, show spinner and fetch
        this.isBusy = true
        await this.fetchChequeDeposit(false)
      }
    },
    posPrintReceipt() {
      this.printerFirstStyle = {
        width: '100%',
        marginLeft: '20%',
        marginRight: '38%',
      }
      this.printerSecondStyle = {
        width: '100%',
        marginLeft: '20%',
        marginRight: '38%',
      }
      setTimeout(() => {
        window.print()
      }, 200)
    },
    billingPrintReceipt() {
      this.printerFirstStyle = {
        width: '55%',
        marginLeft: '10%',
        marginRight: '5%',
      }
      this.printerSecondStyle = {
        width: '100%',
        marginLeft: '25%',
        marginRight: '25%',
      }
      setTimeout(() => {
        window.print()
      }, 200)
    },
    cancelButton() {
      this.hideModal('modal-lg')
    },
    goToAddChequeDeposit() {
      this.$router.push('cheque-deposit')
    },
    async fetchCorporateInformation() {
      try {
        const response = await this.getCorporateInformation({
          permission: 'VIEW_OUTWARD_CHEQUE_DEPOSIT_POSTING',
        })
        const { status, data } = response
        if (status === 200 && data) {
          this.corporateDetails = {
            registeredName: data.data.registeredName,
            registeredAddress: data.data.registeredAddress,
          }
        }
      } catch (error) {
        this.handleError(error)
      }
    },
    async fetchInstitutionData() {
      try {
        const response = await this.getInstitutionData({
          permission: 'VIEW_OUTWARD_CHEQUE_DEPOSIT_POSTING',
        })
        const { status, data } = response
        if (status === 200 && data) {
          this.institutionDetails = {
            regulatoryFooter: data.regulatoryFooter || '',
          }
        }
      } catch (error) {
        this.handleError(error)
      }
    },
    async handleClearCheque(item) {
      const clearCheque = async () => {
        try {
          this.showSpinner = true
          const response = await this.clearChequeAction({
            id: item.id,
            isManual: true,
            initiatedBy: this.userData.username,
            approvedBy: '',
          })
          const { data, status } = response
          if (status === 200 && data.isSuccessful) {
            this.alertSuccess({ text: `${toBalance(item.amount)} ${item.drawerBankName} Chq. No ${item.chequeNumber} IFO ${item.accountName}|${item.accountNumber} has been cleared` })
            this.markTableCacheStale('cheque-deposit')
            this.fetchChequeDeposit(true)
          }
          if (status === 200 && !data.isSuccessful) {
            this.alertError({ text: data.message })
          }
        } catch (error) {
          this.handleError(error)
        } finally {
          this.showSpinner = false
        }
      }

      this.confirm(clearCheque, { title: '', text: this.$t('Are you sure you want to clear this Cheque?') })
    },
    handleReturnCheque(item, _, val) {
      const returnCheque = async () => {
        try {
          this.showSpinner = true
          const response = await this.returnChequeAction({
            id: item.id,
            isCanceled: val === 'cancel',
            initiatedBy: this.userData.username,
            approvedBy: '',
          })
          const { data, status } = response
          if (status === 200 && data.isSuccessful) {
            this.alertSuccess({ text: `${toBalance(item.amount)} ${item.drawerBankName} Chq. No ${item.chequeNumber} IFO ${item.accountName}|${item.accountNumber} has been ${val === 'cancel' ? 'canceled' : 'returned'}` })
            this.markTableCacheStale('cheque-deposit')
            this.fetchChequeDeposit(true)
          }
          if (status === 200 && !data.isSuccessful) {
            this.alertError({ text: data.message })
          }
        } catch (error) {
          this.handleError(error)
        } finally {
          this.showSpinner = false
        }
      }
      const areYouSure = this.$t('Are you sure you want to')
      const thisText = this.$t('this Cheque?')
      this.confirm(returnCheque, { title: '', text: `${areYouSure} ${val === 'cancel' ? this.$t('Cancel') : this.$t('Return')} ${thisText}` })
    },
    async fetchChequeDeposit(isBackground = false) {
      if (!isBackground) {
        this.isBusy = true
        this.hideModal('modal-filter')
      }
      try {
        const response = await this.getPostingsReport({
          search: this.filter,
          page: this.currentPage,
          limit: this.perPage,
          route: 'getChequeDeposits',
          permission: 'VIEW_OUTWARD_CHEQUE_DEPOSIT_POSTING',
        })
        const { status, data } = response
        if (status === 200 && data.data) {
          const cache = this.cachedChequeDepositList
          const isDifferent = !cache || JSON.stringify(cache.data) !== JSON.stringify(data.data)
          if (isDifferent) {
            this.chequeDepositList = data.data.map(item => ({
              ...item,
              clearingDate: item.clearingDate ? toDateWithYear(item.clearingDate) : null,
              dateOnCheque: item.dateOnCheque ? toDateWithYear(item.dateOnCheque) : null,
              financialDate: item.financialDate ? toDateWithYear(item.financialDate) : null,
              transactionDate: item.transactionDate ? toDateWithYear(item.transactionDate) : null,
            }))
            this.totalCount = data.recordCount
            // If on page 1 and data changed, mark all cheque deposit cache as stale
            if (this.currentPage === 1) {
              this.markTableCacheStale('cheque-deposit')
            }
          }
          // Always update cache
          this.setTableCache({
            tableKey: 'cheque-deposit',
            cacheKey: this.cacheKey,
            payload: {
              data: data.data,
              totalCount: data.recordCount,
              lastFetched: Date.now(),
              stale: false,
            },
          })
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        if (!isBackground) this.isBusy = false
      }
    },
    async fetchPostings(referenceNumber) {
      const response = await this.getPostingsReport({
        search: { referenceNumber },
        page: this.transactionCurrentPage,
        limit: this.transactionPerPage,
        route: 'postingsReport',
        permission: 'VIEW_OUTWARD_CHEQUE_DEPOSIT_POSTING',
      })
      const { data, status } = response
      if (status === 200 && data.data) {
        this.transactionList = data.data.map(item => ({
          ...item,
          credit: toBalance(item.credit),
          debit: toBalance(item.debit),
        }))
        this.transactionTotalCount = data.recordCount
      }
    },
    async onViewChequeDeposit(items) {
      try {
        this.showSpinner = true
        this.postingReferenceNumber = items.postingReferenceNumber
        await this.fetchPostings(items.referenceNumber)

        this.chequeDepositData = {
          ...items,
          transactionDate: items.transactionDate ? this.toDateWithYear(items.transactionDate) : null,
          financialDate: items.financialDate ? this.toDateWithYear(items.financialDate) : null,
          credit: items.credit ? toBalance(items.credit) : '',
        }
        this.$root.$emit('bv::show::modal', 'modal-lg')
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    async getAccounts() {
      try {
        const response = await this.getChequeClearingAccountList({
          search: {},
          page: 1,
          limit: 200,
          permission: 'VIEW_OUTWARD_CHEQUE_DEPOSIT_POSTING',
        })
        const { data, status } = response
        if (status === 200 && data.data) {
          this.clearingBankOptions = data.data.map(item => ({
            label: item.accountName,
            value: item.accountNumber.toString(),
          }))
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    resetFilters() {
      this.filter = {
        ...null,
        postingType: 'ChequeDepositPosting',
        recordType: 'Credit',
      }
      this.markTableCacheStale('cheque-deposit')
    },
    resetFilter() {
      this.filter = { ...null }
      this.markTableCacheStale('cheque-deposit')
      this.fetchChequeDeposit(true)
    },
  },
}
</script>
<style lang="scss">
      @media screen {
  #prints {
    display: none;
   }
   .print-footer {
    display: none;
  }
}

@media print {
   html, body {
     height: 99%;
     page-break-after: avoid !important;
     page-break-before: avoid !important;
     visibility:hidden;
  }
  #transaction-receipt-print, #transaction-receipt-print * {
    visibility: visible; border: none;
  }
  #prints, #prints * {
    visibility:visible;
  }
  #prints {
    position:absolute;
    left:0;
    top:0;
    right: 0;
  }
  img {
  max-width: 20%;
  height: auto;
}
.print-footer {
    text-align: center;
    font-size: 14px;
    color: #555;
    border-top: 1px solid #ccc;
    padding: 6px 0;
    background: white;
    margin-top: 8px;
  }
}
.watermark {
    position: relative;
}

.watermark__inner {
    /* Center the content */
    align-items: center;
    display: flex;
    justify-content: center;

    /* Absolute position */
    position: absolute;
    left: 100px;
    top: 0px;
    height: 100%;
    width: 100%;
}

.watermark__body {
    color: rgba(0, 0, 0, 0.1);
    font-size: 5.3rem;
    font-weight: bold;
    white-space: nowrap;
    text-transform: capitalize;
    font-family: "Gill Sans Extrabold", sans-serif !important;
    /* Rotate the text */
    transform: rotate(-60deg);

    /* Disable the selection */
    user-select: none;
}
</style>
